module.exports = __webpack_public_path__ + "media/images/admin/icons/umbrella-b9c9e1198e77e8f4198855b13bb3b64f.svg";